import cx from 'clsx';

import { EnvironmentRibbon } from '..';
import { TProps } from '../types/TProps';

export const EnvironmentRibbonDemo = ({ className, ...props }: TProps) => (
  <EnvironmentRibbon {...props} className={cx('env-ribbon--demo', className)} />
);
